<app-modal
  title="Add Category"
  subtitle="Select a member from the global library"
  (closed)="closed.emit()"
>
  <!-- Category -->
  <div class="flex flex-col gap-1.5 mb-5">
    <label class="text-xs font-semibold text-navy-600 tracking-wider">Category</label>
    <app-select
      placeholder="Select category"
      [options]="categoryOptions()"
      [value]="selectedCategoryId()"
      [error]="showErrors() && !selectedCategoryId()"
      (changed)="selectedCategoryId.set($event)"
    />
    @if (showErrors() && !selectedCategoryId()) {
      <span class="text-2xs text-red-500">Required</span>
    }
  </div>

  <!-- Description -->
  <div class="flex flex-col gap-1.5 mb-5">
    <label class="text-xs font-semibold text-navy-600 tracking-wider">Description</label>
    <textarea
      placeholder="Define category description..."
      rows="4"
      [value]="definition()"
      (input)="definition.set($any($event.target).value)"
      class="w-full resize-none rounded-xl border border-surface-300 px-3 py-2.5 text-xs text-navy-900 placeholder:text-slate-400 focus:ring-2 focus:ring-accent-200 focus:border-accent-500 focus:outline-none transition"
    ></textarea>
  </div>

  <!-- Status -->
  <div class="flex flex-col gap-1.5 mb-2">
    <label class="text-xs font-semibold text-navy-600 tracking-wider">Status</label>
    <div class="flex items-center bg-slate-100 rounded-3xl px-1 py-1 gap-1">
      <button
        type="button"
        (click)="active.set(true)"
        class="flex-1 px-4 py-2 rounded-full text-xs font-medium transition-all cursor-pointer"
        [ngClass]="
          active() ? 'bg-white text-navy-900 shadow-sm' : 'text-slate-500 hover:text-navy-700'
        "
      >
        Active
      </button>
      <button
        type="button"
        (click)="active.set(false)"
        class="flex-1 px-4 py-2 rounded-full text-xs font-medium transition-all cursor-pointer"
        [ngClass]="
          !active() ? 'bg-white text-navy-900 shadow-sm' : 'text-slate-500 hover:text-navy-700'
        "
      >
        Inactive
      </button>
    </div>
  </div>

  <div modal-footer class="flex items-center justify-end gap-3">
    <button
      type="button"
      (click)="closed.emit()"
      class="px-6 py-2.5 text-sm font-semibold text-slate-500 hover:text-navy-900 transition-colors cursor-pointer"
    >
      Cancel
    </button>
    <button
      type="button"
      (click)="onSubmit()"
      [disabled]="submitting()"
      class="px-6 py-2.5 text-sm font-semibold text-white bg-accent-500 hover:opacity-90 rounded-xl transition-opacity cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {{ submitting() ? 'Adding...' : 'Add Category' }}
    </button>
  </div>
</app-modal>
